import React from "react";
import "./not-found.scss";

const NotFound = () => {
  return (
    <div className="not-found">
      <h2>Opps! Something went wrong</h2>
      <p>The page you're looking for couldn't be found.</p>
    </div>
  );
};

export default NotFound;
